import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    event: { type: String, default: "change" }
  }

  connect() {
    // Get all form elements that could trigger submit
    const formElements = this.element.querySelectorAll("input, select, textarea")

    // Add event listener to each form element
    formElements.forEach(element => {
      element.addEventListener(this.eventValue, this.submitForm.bind(this))
    })
  }

  submitForm() {
    // Submit the form
    this.element.requestSubmit()
  }
}
